import { query } from 'src/utils/request';
// 部门报销增长率数据
export async function queryExpenseGrowRateData(data) {
  return query('/zlb/api/sop/statistics/department/expense/grow-rate', {
    method: 'POST',
    data,
  });
}
// 部门报销详情列表数据
export async function queryExpenseDepartmentDetailList(data) {
  return query('/zlb/api/sop/statistics/department/expense/detail-list', {
    method: 'POST',
    data,
  });
}
// 个人报销详情列表数据
export async function queryPersonalDetailList(data) {
  return query('/zlb/api/sop/statistics/personal/expense/detail-list', {
    method: 'POST',
    data,
  });
}
// 个人详细出差，行程聚合
export async function queryExpenseItineraryAggregation(data) {
  return query('/zlb/api/sop/statistics/personal/expense/itinerary/aggregation', {
    method: 'POST',
    data,
  });
}
// 个人详细出差，行程拆分
export async function queryExpenseItinerarySeparate(data) {
  return query('/zlb/api/sop/statistics/personal/expense/itinerary/separate', {
    method: 'POST',
    data,
  });
}
